import { render, staticRenderFns } from "./RatingDelete.vue?vue&type=template&id=9203e080&scoped=true&"
import script from "./RatingDelete.vue?vue&type=script&lang=js&"
export * from "./RatingDelete.vue?vue&type=script&lang=js&"
import style0 from "./RatingDelete.vue?vue&type=style&index=0&id=9203e080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9203e080",
  null
  
)

export default component.exports